export default __webpack_public_path__ + "static/party-682f449b1438863d60d316655882a589.gif";